import { CONTEXT_NAMES } from '@adsk/alloy-helpers';

import {
  createCurrentIdStore,
  CurrentIdStore,
} from '../helpers/createCurrentIdStore';

const FIELD_NAME = 'accountId';

export type CurrentAccountIdContextStore = CurrentIdStore<
  typeof FIELD_NAME,
  string
>;

export const useCurrentAccountIdStore = createCurrentIdStore<
  typeof FIELD_NAME,
  string
>({
  contextName: CONTEXT_NAMES.CurrentAccountIdContext,
  fieldName: FIELD_NAME,
});
